import * as React from 'react';
import { FSK_BANNER_SECTIONS } from '../../../constants/banners/fskBanner';
import { LEAD_REALTOR_EXCEPTION_SECTIONS } from '../../../constants/banners/leadRealtorBanner';
import { FSK_SP_REGIONS } from '../../../constants/specialProjects/fskSpecialProject';
import { FSKMortgageBanner } from '../../../components/FSKMortgageBanner';
import { LeadRealtorBanner } from '../../../components/LeadRealtorBanner';
import { IDropdownMenuLink } from '../../../types/dropdownMenuLink';
import { TDropdownType } from '../../../components/DropdownMenu/interfaces';
import { IOtherLinksSchema } from '../../../repositories/header/entities/other_links/OtherLinksSchema';

export interface IGetBanner {
  links: IDropdownMenuLink[];
  name: TDropdownType;
  linksOther: IOtherLinksSchema;
  regionId?: number;
  isOpen?: boolean;
}

export function getBanner({ name, links, linksOther, regionId, isOpen }: IGetBanner): React.ReactElement | null {
  let Banner: React.ReactElement | null = null;

  if (regionId && FSK_BANNER_SECTIONS.includes(name) && FSK_SP_REGIONS.includes(regionId)) {
    Banner = <FSKMortgageBanner isOpen={isOpen} />;
  } else if (!LEAD_REALTOR_EXCEPTION_SECTIONS.includes(name) && links.length < 3) {
    Banner = <LeadRealtorBanner url={linksOther.leadRealtorForm} isShown={isOpen} />;
  }

  return Banner;
}
